import angular from 'angular';
import uiRouter from 'angular-ui-router';
import appsComponent from './apps.component';
import ProjectManager from './projectManager/projectManager';
import Youtube from './youtube/youtube';
import NewsList from './newsList/newsList';

let appsModule = angular.module('apps', [uiRouter, ProjectManager, Youtube, NewsList])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps', {
        url: '/apps',
        component: 'apps',
        resolve: {
          $title: () => 'APPs'
        }
      });
  })
  .component('apps', appsComponent)
  .name;

export default appsModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/apps.js